// src/components/Admin/CreditAddModal.js
"use client";

import { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import api from "../../services/api";
import MoneyInput from "../../components/Custombb/MoneyInput";
import Swal from "sweetalert2";

const CreditAddModal = ({ show, onHide, userId, onSuccess, targetType = "USER", targetId }) => {
  // targetType: "USER" | "CATEGORY"
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [amount, setAmount] = useState("");
  const [type, setType] = useState("CHARGE"); // CHARGE | DEDUCT
  const [categoryId, setCategoryId] = useState(null); // Product Category ID
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchCategories(); // تابع جهت گرفتن دسته‌بندی‌ها
  }, []);

  const fetchCategories = async () => {
    try {
      const response = await api.get('/merchant-categories?isActive=true');
      setCategoryOptions(response.data);
    } catch (err) {
      console.error('Failed to fetch categories', err);
    }
  };

  // Reset form on open
  useEffect(() => {
    if (show) {
      setAmount("");
      setType("CHARGE");
    }
  }, [show]);

  const handleAddCredit = async () => {
    if (!amount || isNaN(Number(amount))) {
      Swal.fire({ icon: "error", title: "خطا", text: "مبلغ معتبر وارد کنید" });
      return;
    }

    setLoading(true);

    try {
      if (targetType === "USER") {
        await api.post(`/admin/users/${userId}/credit/add`, {
          amount: Number(amount),
          type,
          categoryId,
        });
        Swal.fire({ icon: "success", title: "موفقیت", text: "اعتبار با موفقیت تغییر یافت", timer: 2000, showConfirmButton: false });
      } else if (targetType === "CATEGORY") {
        await api.post(`/admin/categories/${targetId}/credit/add`, {
          amount: Number(amount),
          type,
          categoryId,
        });
        Swal.fire({ icon: "success", title: "موفقیت", text: "اعتبار دسته با موفقیت تغییر یافت", timer: 2000, showConfirmButton: false });
      }
      onSuccess?.();
      onHide();
    } catch (err) {
      console.error(err);
      Swal.fire({
        icon: "error",
        title: "خطا",
        text: err.response?.data?.message || "خطا در تغییر اعتبار",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>{targetType === "USER" ? "تغییر اعتبار کاربر" : "تغییر اعتبار دسته"}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group className="mb-3">
          <Form.Label>مبلغ (تومان)</Form.Label>
          <MoneyInput
            value={amount} // amount = "150000" (raw digits)
            onChange={(raw) => setAmount(raw)}
            placeholder="مبلغ را وارد کنید"
            required
          />
        </Form.Group>

        <Form.Group>
          <Form.Label>نوع تغییر</Form.Label>
          <Form.Select value={type} onChange={(e) => setType(e.target.value)}>
            <option value="CHARGE">افزایش</option>
            <option value="DEDUCT">کاهش</option>
          </Form.Select>
        </Form.Group>
        
        <Form.Group className="mb-3">
          <Form.Label>انتخاب دسته‌بندی (اختیاری)</Form.Label>
          <Form.Select
            value={categoryId}
            onChange={(e) => setCategoryId(e.target.value)}
          >
            <option value="">همه دسته‌ها</option>
            {categoryOptions.map((cat) => (
              <option key={cat.id} value={cat.id}>{cat.title}</option>
            ))}
          </Form.Select>
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>انصراف</Button>
        <Button variant="primary" onClick={handleAddCredit} disabled={loading}>
          {loading ? "در حال ارسال..." : "اعمال تغییر"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CreditAddModal;
